import terminatorErrorMessage from './terminatorErrorMessage'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Row, Col, Alert, Button } from 'react-bootstrap'
import { getTerminatorWinners } from '@severed-links/common.redherrings-reducers/terminator'
import * as s from '../Eliminator/EliminatorWinners.scss'
import EliminatorWinnerCard from '../Eliminator/EliminatorWinnerCard'

const TerminatorWinners = () => {
    
    const [error, setError] = useState('')
    const [refresh, setRefresh] = useState(0)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const winners = useSelector(state => state.terminator.winners)
    const isFetching = useSelector(state => state.terminator.isFetching)
    
    useEffect(() => {
        let active = true
        const load = async () => {
            try {
                const action = await dispatch(getTerminatorWinners())
                if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to load winners.')
                if (active) setError('')
            } catch (error) { if (active) setError(terminatorErrorMessage(error)) }
        }
        load()
        const timer = setInterval(load, 30000)
        return () => { active = false; clearInterval(timer) }
    }, [dispatch, refresh])

    return (
        <div className={s.container}>
            {error ? <Alert variant='danger'>{error} <Button onClick={() => setRefresh(value => value + 1)}>Retry</Button></Alert> : null}
            <div className={s.heading}>
                <div className={s.eyebrow}>Terminator</div>
                <h2 className={s.title}>Winners</h2>
            </div>
            {!isFetching && (!winners || !winners.length) ?
            <div className={s.noWinners}>
                No winners located.
            </div>
            : null}
            <Row className={s.cardContainer}>
            {winners && winners.map(i =>
            <Col xs={12} sm={12} md={6} xl={4}
                key={`winner-card-${i.seasonName}`}
                className={s.winnerCol}>
                <EliminatorWinnerCard winner={i} onClick={_seasonName => navigate(`/terminator/standings/${encodeURIComponent(i.seasonName)}`)}>
                    {i.hasRunnersUp && i.runnersUp?.length ?
                    <div className={s.runnersUp}>
                        <div className={s.runnersUpLabel}>{i.runnersUp.length === 1 ? 'Runner-up' : 'Runners-up'}</div>
                        <ul className={s.runnersUpList}>
                            {i.runnersUp.map(p => <li key={p.playerId}>{p.firstName} {p.lastName}</li>)}
                        </ul>
                    </div>
                    : null}
                </EliminatorWinnerCard>
            </Col>
            )}
            </Row>
        </div>
    )
}

export default TerminatorWinners
